import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq, axiosReq2 } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {  Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
// import SelectBoxIcon from "../../assets/icon/general/SelectBoxIcon";
import SelectBoxIcon2 from "../../../assets/icon/SelectBoxIcon2";
import Select from "react-select";
const AddModalRagAccess = ({ setShowModal, title, buttonName, setRecheck, reCheck, data, setSettingModal, setData,id }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();
    const [selectedNumberOfContents, setSelectedNumberOfContents] = useState()


    const [allValues, setAllValues] = useState({
        Name: '',


    });
    const [allValuesError, setAllValuesError] = useState({
        Name: false,

    });





    const addAdmin = async () => {
    
            var res = allFull(allValues)
            console.log(res)
            console.log(allValues?.Name)
            console.log(id)
            if (res) {
                const dataUser = await axiosReq2("admin/rag_access", "post", {
                    user_id: id,
                    rag_system_id: allValues?.Name?.id,
                

                });
                console.log(dataUser)
                if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                       setRecheck(!reCheck)
                        setShowModal(false)
                        alert("موفقیت آمیز");

                }
                else {
                    console.log(allValuesError)
                    setEroor(dataUser?.data)

                    setShowErrorModalStep1(true);
                }
            }
            else {
                setEroor("لطفا موارد خواسته شده را وارد نمایید")

                console.log(allValuesError)
                setShowErrorModalStep1(true);

            }
        
    }

    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && o != "IsAdmin") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }


    return (
        <>
          
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <div className='w-full mt-2 '>
                                    <Listbox value={selectedNumberOfContents} onChange={(e) => { setSelectedNumberOfContents(e);
                                         setAllValues({ ...allValues, Name: e })
                                          }}>
                                        {/* <Label className="block text-sm/6 font-medium text-gray-900">Assigned to</Label> */}
                                        <div className="relative w-full">
                                            <ListboxButton className="relative w-full h-[48px] cursor-default rounded-md bg-white shadow-searchShadow py-1 px-2 text-right  ring-[1px] ring-inset ring-borderGray focus:outline-none  focus:ring-indigo-500 sm:text-sm/6">
                                                <span className="flex items-center">
                                                    {selectedNumberOfContents?.name ?
                                                        <span className="ml-3 block truncate font-IRANYekanExtra text-mainBlue text-[15px]">{selectedNumberOfContents?.name}</span>

                                                        :
                                                     
                                                            <span className="ml-3 block truncate font-IRANYekanExtra text-mainBlue text-[15px] ">انتخاب کنید</span>
                                                    }

                                                </span>
                                                <span className="pointer-events-none absolute inset-y-0 left-0 ml-3 flex items-center pr-2">
                                                    <SelectBoxIcon2 aria-hidden="true" />
                                                </span>
                                            </ListboxButton>

                                            <ListboxOptions
                                                transition
                                                className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white  text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                            >
                                                {data?.map((item) => (
                                                    <ListboxOption
                                                        key={item.id}
                                                        value={item}
                                                        className="group relative cursor-default select-none py-[7px] px-3 text-gray-900 border-b-[1px] border-black/5 text-[12px] data-[focus]:bg-bgGray"
                                                    >
                                                        <div className="flex items-center">
                                                            <span className="ml-3 block truncate font-IRANYekanMedium text-[14px]  group-data-[selected]:font-IRANYekanBold">
                                                                {item.name}
                                                            </span>
                                                        </div>
                                                    </ListboxOption>
                                                ))}
                                            </ListboxOptions>
                                        </div>
                                    </Listbox>
                                </div>

                            </div>
                        </div>
                            <div className="flex justify-center">
                                <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                                <button onClick={() => addAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                            </div>
                    </div>
                    {showErrorModalStep1 ?
                        <>
                            <div
                                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                            >
                                <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                    <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                        <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                            <span className="text-base font-bold   text-red">
                                                درخواست اشتباه !
                                            </span>

                                        </div>

                                        <div className="relative px-4 py-1 flex-auto">
                                            <p className="my-4 text-black text-sm   leading-relaxed">
                                                {error}
                                            </p>
                                        </div>

                                        <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                            <Link

                                                className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                                type="button"
                                                onClick={() => setShowErrorModalStep1(false)}
                                            >
                                                فهمیدم
                                            </Link>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                        </>
                        : null
                    }
                </div>
          </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black">
                    
                </div>
          
            </>
            )
}

            export default AddModalRagAccess;